(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Treatment', Treatment);

    Treatment.$inject = ['$resource'];

    function Treatment ($resource) {
        var resourceUrl =  'api/treatments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByPracticesOfPractitioner': {
                method: 'GET',
                isArray: true,
                url: 'api/treatments/byPracticesOfPractitioner/:practitionerId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
